import moment from 'moment';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { Spinner } from 'react-activity';
import DatePicker from 'react-datepicker';
import { editAvailability } from '../../action/educator/AvailablityAction';
import { RESPONSE_CONSTANT } from '../../../utils/ResponseConstant';
import { showNotification } from '../../action/NotificationAction';
import { editCustomAvailability } from '../../action/educator/CustomAvailablity';

class Availabilty extends Component {
    static propTypes = {
        availTiming: PropTypes.array,
        customAvailTiming: PropTypes.array,
        deleteAvail: PropTypes.func,
        isTabName: PropTypes.array,
    };

    constructor(props) {
        super(props);
        this.state = {
            deleteId: '',
            deleteModalOpen: false,
            availabilityDays: [
                { availabilityId: 1, availabilityDay: 'Sunday', isChecked: false },
                { availabilityId: 2, availabilityDay: 'Monday', isChecked: false },
                { availabilityId: 3, availabilityDay: 'Tuesday', isChecked: false },
                { availabilityId: 4, availabilityDay: 'Wednesday', isChecked: false },
                { availabilityId: 5, availabilityDay: 'Thursday', isChecked: false },
                { availabilityId: 6, availabilityDay: 'Friday', isChecked: false },
                { availabilityId: 7, availabilityDay: 'Saturday', isChecked: false },
            ],
            isEdit: false,
            isOnDemand: false,
            isLoading: false,
            selectedStartDate: null,
            selectedEndDate: null,
        };
    }

    // closeAvailabilityModal
    closeAvailabilityModal = () => {
        this.setState({
            cancelAvailabilityIsOpen: false,
            cancelCustomAvailabilityIsOpen: false,
        });
        this.setState({
            startTimee: '',
            startTime: '',
            endTime: '',
            endTimee: '',
            selectedStartDate: '',
            selectedEndDate: '',
        });
    };

    //handleStartDateChange
    handleStartDateChange = (date) => {
        const { selectedEndDate } = this.state;
        const selectedStartDate = moment(date).format('YYYY-MM-DD');
        if (selectedEndDate && moment(selectedStartDate).isAfter(selectedEndDate)) {
            this.props.showNotification(
                'Start date cannot be greater than end date.',
                RESPONSE_CONSTANT.WARNING
            );
        } else {
            this.setState({ selectedStartDate: date }, () => {});
        }
    };

    //handleEndDateChange
    handleEndDateChange = (date) => {
        const { selectedStartDate } = this.state;
        if (!selectedStartDate) return;
        const startDate = moment(selectedStartDate);
        const endDate = moment(date);
        if (endDate.isBefore(startDate, 'day')) {
            this.props.showNotification(
                'End date cannot be less than start date.',
                RESPONSE_CONSTANT.WARNING
            );
        } else {
            this.setState({ selectedEndDate: date });
        }
    };

    // openAvailalibiltyModal
    openAvailalibiltyModal = () => {
        const { cancelAvailabilityIsOpen, modalTitle } = this.state;
        return (
            <Modal
                overlayClassName={'modal-background z-index-1'}
                isOpen={cancelAvailabilityIsOpen}
                onRequestClose={this.closeAvailabilityModal}
                className={'modal-width'}
                contentLabel="Example"
                ariaHideApp={false}
            >
                <div className="relative w-full max-w-2xl max-h-full">
                    <div className="relative p-6 rounded-lg">
                        <div className="flex items-start justify-between">
                            <h5 className="mt-0 mb-5 text-lg font-medium text-black">
                                {modalTitle}
                            </h5>
                            <button type="button" onClick={() => this.closeAvailabilityModal()}>
                                <svg
                                    className="styles_closeIcon__1QwbI"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="28"
                                    height="28"
                                    viewBox="0 0 36 36"
                                >
                                    <path
                                        fill="white"
                                        d="M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z"
                                    ></path>
                                </svg>
                            </button>
                        </div>
                        <div className="flex items-center gap-2">
                            <input
                                onChange={() => {
                                    this.setState({ isOnDemand: !this.state.isOnDemand });
                                }}
                                checked={this.state.isOnDemand}
                                type="checkbox"
                                className=""
                            />
                            <label htmlFor="select-subject" className="m-0 text-base text-black">
                                Available for On-demand
                            </label>
                        </div>
                        <div className="grid gap-4 mt-8 sm:grid-cols-4">
                            {this.state.availabilityDays &&
                                this.state.availabilityDays.map((avail) => (
                                    <div
                                        key={avail.availabilityId}
                                        className="flex items-center gap-2"
                                    >
                                        <label>
                                            <input
                                                key={avail.availabilityId}
                                                onChange={this.handleCheckChieldElement}
                                                type="checkbox"
                                                checked={avail.isChecked}
                                                value={avail.availabilityDay}
                                                disabled={this.state.isEdit}
                                            />{' '}
                                            <span>{avail.availabilityDay}</span>
                                        </label>
                                    </div>
                                ))}
                        </div>
                        <div className="grid gap-8 mt-8 sm:grid-cols-2">
                            <div>
                                <label
                                    htmlFor="time"
                                    className="block mb-2 text-base font-normal leading-6 text-black"
                                >
                                    Start Time
                                </label>
                                <div className="flex w-full mb-2 rounded border-black-10">
                                    <input
                                        id="time"
                                        label="Start Time"
                                        name="from_time"
                                        type="time"
                                        className="w-full p-1.5 rounded text-black placeholder:text-secondary text-base"
                                        defaultValue={this.state.startTimee}
                                        onChange={(event) => this.handleStartTime(event)}
                                    />
                                </div>
                            </div>
                            <div>
                                <label
                                    htmlFor="time"
                                    className="block mb-2 text-base font-normal leading-6 text-black"
                                >
                                    End Time
                                </label>
                                <div className="flex w-full mb-2 rounded border-black-10">
                                    <input
                                        id="time"
                                        label="End Time"
                                        type="time"
                                        name="to_time"
                                        className="w-full p-1.5 rounded text-black placeholder:text-secondary text-base"
                                        defaultValue={this.state.endTimee}
                                        onChange={(event) => this.handleEndTime(event)}
                                    />
                                </div>
                            </div>
                        </div>
                        <p className="my-8 text-base text-black">
                            Editing this schedule may interfere with any of your existing
                            appointments. By editing this schedule, you will adhere to the
                            Cancellation Policy.
                        </p>
                        <div className="flex items-center justify-end mt-6 space-x-4">
                            <button
                                data-modal-hide="defaultModal"
                                className="text-red border-red ring-1 ring-inset ring-red rounded-lg font-semibold text-base sm:w-3/12 w-full py-1.5"
                                onClick={this.closeAvailabilityModal}
                            >
                                Cancel
                            </button>
                            <button
                                data-modal-hide="defaultModal"
                                className="text-white bg-primary rounded-lg font-semibold text-base sm:w-3/12 w-full py-1.5"
                                onClick={this.availSave}
                                disabled={this.state.isLoading}
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                >
                                    {this.state.isLoading ? <Spinner color="#FFF" /> : 'Modify'}
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    };

    //openCustomAvailalibiltyModal
    openCustomAvailalibiltyModal = () => {
        const { cancelCustomAvailabilityIsOpen, modalTitle, startTime, endTime } = this.state;
        const startTimeTime = startTime ? startTime.split(' ')[1] : '';
        const endTimeTime = endTime ? endTime.split(' ')[1] : '';
        return (
            <Modal
                overlayClassName={'modal-background z-index-1'}
                isOpen={cancelCustomAvailabilityIsOpen}
                onRequestClose={this.closeAvailabilityModal}
                className={'modal-width'}
                contentLabel="Example"
                ariaHideApp={false}
            >
                <div className="relative w-full max-w-2xl max-h-full">
                    <div className="relative p-6 rounded-lg">
                        <div className="flex items-start justify-between">
                            <h5 className="mt-0 mb-5 text-lg font-medium text-black">
                                {modalTitle}
                            </h5>
                            <button type="button" onClick={() => this.closeAvailabilityModal()}>
                                <svg
                                    className="styles_closeIcon__1QwbI"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="28"
                                    height="28"
                                    viewBox="0 0 36 36"
                                >
                                    <path
                                        fill="white"
                                        d="M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z"
                                    ></path>
                                </svg>
                            </button>
                        </div>
                        <div className="flex items-center gap-2">
                            <input
                                onChange={() => {
                                    this.setState({ isOnDemand: !this.state.isOnDemand });
                                }}
                                checked={this.state.isOnDemand}
                                type="checkbox"
                                className=""
                            />
                            <label htmlFor="select-subject" className="m-0 text-base text-black">
                                Available for On-demand
                            </label>
                        </div>
                        <div className="grid gap-8 mt-6 sm:grid-cols-2">
                            <div className="inputgroup">
                                <label
                                    htmlFor="select-date"
                                    className="block mt-6 mb-2 text-base font-normal text-black rounded"
                                >
                                    Start Date
                                </label>
                                <div className="relative flex flex-wrap items-stretch w-full mb-0">
                                    <div className="flex w-full mb-2 rounded border-black-10">
                                        <div className="grow">
                                            <DatePicker
                                                name="start-date"
                                                className="w-full px-2 text-base text-black placeholder:text-secondary datepicker-opacity example-custom-input"
                                                wrapperClassName={'w-full'}
                                                placeholderText="Select start date"
                                                selected={
                                                    this.state.selectedStartDate
                                                        ? new Date(this.state.selectedStartDate)
                                                        : null
                                                }
                                                onChange={this.handleStartDateChange}
                                                dropdownMode="select"
                                                showMonthDropdown
                                                showYearDropdown
                                                scrollableYearDropdown
                                                maxDate={
                                                    new Date(moment(new Date()).add(6, 'months'))
                                                }
                                                minDate={new Date()}
                                                autoComplete="off"
                                                popperPlacement="right-start"
                                                popperModifiers={[
                                                    {
                                                        name: 'offset',
                                                        options: {
                                                            offset: [10, 10],
                                                        },
                                                    },
                                                ]}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="inputgroup">
                                <label
                                    htmlFor="select-date"
                                    className="block mt-6 mb-2 text-base font-normal text-black rounded"
                                >
                                    End Date
                                </label>
                                <div className="relative flex flex-wrap items-stretch w-full mb-0">
                                    <div className="flex w-full mb-2 rounded border-black-10">
                                        <div className="grow">
                                            <DatePicker
                                                name="end-date"
                                                className="w-full px-2 text-base text-black placeholder:text-secondary datepicker-opacity example-custom-input"
                                                wrapperClassName={'w-full'}
                                                placeholderText="Select end date"
                                                selected={
                                                    this.state.selectedEndDate
                                                        ? new Date(this.state.selectedEndDate)
                                                        : null
                                                }
                                                onChange={this.handleEndDateChange}
                                                dropdownMode="select"
                                                showMonthDropdown
                                                showYearDropdown
                                                scrollableYearDropdown
                                                maxDate={
                                                    new Date(moment(new Date()).add(6, 'months'))
                                                }
                                                minDate={new Date()}
                                                autoComplete="off"
                                                popperPlacement="left-start"
                                                popperModifiers={[
                                                    {
                                                        name: 'offset',
                                                        options: {
                                                            offset: [10, 10],
                                                        },
                                                    },
                                                ]}
                                                defaultValue={
                                                    this.state.endTime
                                                        ? this.state.endTime.split(' ')[0]
                                                        : ''
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="grid gap-8 mt-8 sm:grid-cols-2">
                            <div>
                                <label
                                    htmlFor="time"
                                    className="block mb-2 text-base font-normal leading-6 text-black"
                                >
                                    Start Time
                                </label>
                                <div className="flex w-full mb-2 rounded border-black-10">
                                    <input
                                        id="time"
                                        label="Start Time"
                                        name="from_time"
                                        type="time"
                                        className="w-full p-1.5 rounded text-black placeholder:text-secondary text-base"
                                        defaultValue={startTimeTime}
                                        onChange={(event) => this.handleStartTime(event)}
                                    />
                                </div>
                            </div>
                            <div>
                                <label
                                    htmlFor="time"
                                    className="block mb-2 text-base font-normal leading-6 text-black"
                                >
                                    End Time
                                </label>
                                <div className="flex w-full mb-2 rounded border-black-10">
                                    <input
                                        id="time"
                                        label="End Time"
                                        type="time"
                                        name="to_time"
                                        className="w-full p-1.5 rounded text-black placeholder:text-secondary text-base"
                                        defaultValue={endTimeTime}
                                        onChange={(event) => this.handleEndTime(event)}
                                    />
                                </div>
                            </div>
                        </div>
                        <p className="my-8 text-base text-black">
                            Editing this schedule may interfere with any of your existing
                            appointments. By editing this schedule, you will adhere to the
                            Cancellation Policy.
                        </p>
                        <div className="flex items-center justify-end mt-6 space-x-4">
                            <button
                                data-modal-hide="defaultModal"
                                className="text-red border-red ring-1 ring-inset ring-red rounded-lg font-semibold text-base sm:w-3/12 w-full py-1.5"
                                onClick={this.closeAvailabilityModal}
                            >
                                Cancel
                            </button>
                            <button
                                data-modal-hide="defaultModal"
                                className="text-white bg-primary rounded-lg font-semibold text-base sm:w-3/12 w-full py-1.5"
                                onClick={this.availSave}
                                disabled={this.state.isLoading}
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                >
                                    {this.state.isLoading ? <Spinner color="#FFF" /> : 'Modify'}
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    };

    // openAvailModal
    openAvailModal = (data) => {
        const { availabilityDays } = this.state;
        const selectedDays = availabilityDays.map((day) => ({
            ...day,
            isChecked: data.day === day.availabilityDay,
        }));
        this.setState({
            isStartFilled: false,
            isEndFilled: false,
            startTimee: data.startTime,
            endTimee: data.endTime,
            availabilityId: data.id,
            isEdit: true,
            isOnDemand: data.availablePerOnDemand,
            availabilityDays: selectedDays,
            cancelAvailabilityIsOpen: true,
            modalTitle: 'Edit Schedule',
            Submit: 'Save',
            scheduleId: '',
            isLoading: false,
        });
    };

    // openCustomAvailModal
    openCustomAvailModal = (data, isTabName) => {
        this.setState({
            selectedStartDate: data.startTime,
            selectedEndDate: data.endTime,
            isStartFilled: false,
            isEndFilled: false,
            startTime: data.startTime,
            endTime: data.endTime,
            availabilityId: data.id,
            isEdit: true,
            isOnDemand: data.availablePerOnDemand,
            cancelCustomAvailabilityIsOpen: true,
            modalTitle: 'Edit Schedule',
            Submit: 'Save',
            scheduleId: '',
            isLoading: false,
        });
    };

    // closeDeleteModal
    closeDeleteModal = () => {
        this.setState({
            deleteModalOpen: false,
        });
    };

    //openDeleteModal
    openDeleteModal = () => {
        const { deleteModalOpen } = this.state;
        return (
            <Modal
                isOpen={deleteModalOpen}
                overlayClassName={'modal-background z-index-1'}
                onRequestClose={this.closeDeleteModal}
                // style={customStyles}
                className={'modal-width'}
                contentLabel="Example"
                ariaHideApp={false}
            >
                <div className="relative w-full max-w-2xl max-h-full">
                    <div className="relative p-6 bg-white rounded-lg">
                        <p className="text-black">
                            Deleting this schedule may interfere with any of your existing
                            appointments. By deleting this schedule, you will adhere to the
                            Cancellation Policy.
                        </p>
                        <p className="text-black">Would you like to delete the schedule?</p>
                        <div className="flex items-center justify-end mt-6 space-x-4">
                            <button
                                data-modal-hide="defaultModal"
                                type="button"
                                className="w-3/12 py-2 text-base font-semibold rounded-lg text-red border-red ring-1 ring-inset ring-red"
                                onClick={this.closeDeleteModal}
                            >
                                Cancel
                            </button>
                            <button
                                data-modal-hide="defaultModal"
                                className="w-3/12 py-2 text-base font-semibold text-white rounded-lg bg-primary"
                                onClick={() => {
                                    this.props.deleteAvail(this.state.deleteId);
                                    this.setState({ deleteModalOpen: false });
                                }}
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    };

    // openDelete
    openDelete = (id) => {
        this.setState({ deleteModalOpen: true, deleteId: id });
    };

    //handleCheckChieldElement
    handleCheckChieldElement = (event) => {
        let availabilityDayNew = this.state.availabilityDays;
        availabilityDayNew.forEach((avail) => {
            if (avail.availabilityDay === event.target.value)
                avail.isChecked = event.target.checked;
        });
        this.setState({ availabilityDays: availabilityDayNew });
    };

    //handleStartTime
    handleStartTime = (event) => {
        const date = new Date();
        const dateAsString = date.toString();
        const timeZone = moment.tz(dateAsString).zoneAbbr();
        this.setState({ timeZone: timeZone, startTimee: event.target.value });
        if (event.target.value !== '') {
            this.setState({ isStartFilled: true });
        } else {
            this.setState({ isStartFilled: false });
        }
    };
    // handleEndTime
    handleEndTime = (event) => {
        const date = new Date();
        const dateAsString = date.toString();
        const timeZone = moment.tz(dateAsString).zoneAbbr();
        this.setState({ timeZone: timeZone, endTimee: event.target.value });
        if (event.target.value !== '') {
            this.setState({ isEndFilled: true });
        } else {
            this.setState({ isEndFilled: false });
        }
    };

    // availSave
    availSave = () => {
        const { availabilityDays, selectedStartDate, selectedEndDate } = this.state;
        const { isTabName } = this.props;
        const formattedStartDate = moment(selectedStartDate);
        const formattedEndDate = moment(selectedEndDate);
        if (isTabName === 'custom') {
            if (!selectedStartDate || !selectedEndDate) {
                this.props.showNotification(
                    'Please select both start and end dates.',
                    RESPONSE_CONSTANT.WARNING
                );
                return;
            }
            if (
                (!this.state.startTime || !this.state.endTime) &&
                (this.state.startTimee === '' || this.state.endTimee === '')
            ) {
                this.props.showNotification(
                    'Please select both start and end times.',
                    RESPONSE_CONSTANT.WARNING
                );
                return;
            }
            const startTime = this.state.isStartFilled
                ? this.state.startTimee + ':00'
                : this.state.startTime.split(' ')[1];
            const endTime = this.state.isEndFilled
                ? this.state.endTimee + ':00'
                : this.state.endTime.split(' ')[1];
            let startMoment = moment(startTime, 'HH:mm:ss');
            let endMoment = moment(endTime, 'HH:mm:ss');

            if (startMoment.isSame(endMoment)) {
                this.props.showNotification(
                    RESPONSE_CONSTANT.START_AND_END_TIME_NOT_SAME,
                    RESPONSE_CONSTANT.WARNING
                );
                return;
            }
            if (endMoment.isBefore(startMoment)) {
                this.props.showNotification(
                    RESPONSE_CONSTANT.END_TIME_LESS_THAN_START_TIME,
                    RESPONSE_CONSTANT.WARNING
                );
                return;
            }
            if (endMoment.diff(startMoment, 'minutes') < 15) {
                this.props.showNotification(
                    RESPONSE_CONSTANT.MINUMUM_SLOT_DURATION,
                    RESPONSE_CONSTANT.WARNING
                );
                return;
            }
            this.setState({ isLoading: true });
            const values = {
                startDate: formattedStartDate.format('YYYY-MM-DD'),
                endDate: formattedEndDate.format('YYYY-MM-DD'),
                startTime: startTime,
                endTime: endTime,
                onDemandAccept: this.state.isOnDemand,
            };
            let availableId = this.state.availabilityId;
            this.props.editCustomAvailability(availableId, values, (response) => {
                this.setState({ isLoading: false });
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    this.props.showNotification(response.message, RESPONSE_CONSTANT.SUCCESS);
                    this.setState({ isTabName: 'custom' });
                    this.closeAvailabilityModal();
                    this.props.loadAvailList();
                    this.setState({ cancelCustomAvailabilityIsOpen: false });
                } else {
                    if (response.message) {
                        this.props.showNotification(response.message, RESPONSE_CONSTANT.ERROR);
                    }
                }
            });
            return;
        }
        if (availabilityDays && availabilityDays.length) {
            var avail = [];
            availabilityDays.forEach((response) => {
                if (response.isChecked) {
                    avail.push(response.availabilityId);
                }
            });
            var availTime = {};
            var availabilityTime = [];
            availTime['startTime'] = this.state.isStartFilled
                ? this.state.startTimee + ':00'
                : this.state.startTimee;
            availTime['endTime'] = this.state.isEndFilled
                ? this.state.endTimee + ':00'
                : this.state.endTimee;
            availabilityTime.push(availTime);
            if (avail.length) {
                if (this.state.startTimee === '') {
                    this.props.showNotification(
                        RESPONSE_CONSTANT.START_TIME_MANDATORY,
                        RESPONSE_CONSTANT.WARNING
                    );
                    return;
                }
                if (this.state.endTimee === '') {
                    this.props.showNotification(
                        RESPONSE_CONSTANT.END_TIME_MANDATORY,
                        RESPONSE_CONSTANT.WARNING
                    );
                    return;
                }
                if (this.state.startTimee !== '' && this.state.endTimee !== '') {
                    let startTime = moment(availTime['startTime'], 'hh:mm:ss a');
                    let endTime = moment(availTime['endTime'], 'hh:mm:ss a');
                    if (availTime['startTime'] === availTime['endTime']) {
                        this.props.showNotification(
                            RESPONSE_CONSTANT.START_AND_END_TIME_NOT_SAME,
                            RESPONSE_CONSTANT.WARNING
                        );
                        return;
                    }
                    if (endTime.isBefore(startTime)) {
                        this.props.showNotification(
                            RESPONSE_CONSTANT.END_TIME_LESS_THAN_START_TIME,
                            RESPONSE_CONSTANT.WARNING
                        );
                        return;
                    }
                    if (endTime.diff(startTime, 'minutes') < 15) {
                        this.props.showNotification(
                            RESPONSE_CONSTANT.MINUMUM_SLOT_DURATION,
                            RESPONSE_CONSTANT.WARNING
                        );
                        return;
                    }
                    this.setState({ isLoading: true });
                    const values = {
                        availableDays: avail,
                        availableTimes: availabilityTime,
                        availabilityId: this.state.availabilityId,
                        onDemandAccepted: this.state.isOnDemand,
                    };
                    this.props.editAvailability(values, (response) => {
                        this.setState({ isLoading: false });
                        if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                            this.props.showNotification(
                                response.message,
                                RESPONSE_CONSTANT.SUCCESS
                            );
                            this.closeAvailabilityModal();
                            this.props.loadAvailList();
                        } else {
                            if (response.message) {
                                this.props.showNotification(
                                    response.message,
                                    RESPONSE_CONSTANT.ERROR
                                );
                            }
                        }
                    });
                }
            } else {
                if (isTabName === 'manage') {
                    this.props.showNotification(
                        RESPONSE_CONSTANT.DAY_MANDATORY,
                        RESPONSE_CONSTANT.WARNING
                    );
                }
                return;
            }
        }
    };

    render() {
        const { availTiming, customAvailTiming } = this.props;

        return (
            <>
                <div id="myTabContent">
                    {this.props.isTabName === 'manage' ? (
                        <div
                            className="pt-4 overflow-x-auto rounded-lg bg-card"
                            id="manage"
                            role="tabpanel"
                            aria-labelledby="manage-tab"
                        >
                            <table className="w-full table-bordered">
                                <thead className="text-left text-UInew border-bottom whitespace-nowrap">
                                    <tr>
                                        <th scope="col" className="p-3 font-medium">
                                            Schedule Name
                                        </th>
                                        <th scope="col" className="p-3 font-medium">
                                            Availability Timing
                                        </th>
                                        <th scope="col" className="p-3 font-medium">
                                            Availability Days
                                        </th>
                                        <th scope="col" className="p-3 font-medium">
                                            On Demand
                                        </th>
                                        <th scope="col" className="p-3 font-medium">
                                            Actions
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="text-white break-word">
                                    {availTiming && availTiming.length ? (
                                        availTiming.map((availabilityTimes, index) => {
                                            return (
                                                <tr
                                                    key={index}
                                                    className="border-bottom whitespace-nowrap"
                                                >
                                                    <td className="p-3">Schedule {index + 1}</td>
                                                    <td className="p-3">
                                                        {moment(
                                                            availabilityTimes.startTime,
                                                            'HH:mm:ss'
                                                        ).format('LT') +
                                                            ' to ' +
                                                            moment(
                                                                availabilityTimes.endTime,
                                                                'HH:mm:ss'
                                                            ).format('LT')}
                                                        &nbsp;&nbsp;{this.props.timezoneName}
                                                    </td>
                                                    <td className="p-3">{availabilityTimes.day}</td>
                                                    <td className="p-3">
                                                        {availabilityTimes.availablePerOnDemand
                                                            ? 'Yes'
                                                            : 'No'}
                                                    </td>
                                                    <td className="p-3 text-center">
                                                        <div className="flex gap-2">
                                                            <i
                                                                className="text-white fal fa-edit"
                                                                aria-hidden="true"
                                                                style={{ cursor: 'pointer' }}
                                                                onClick={() =>
                                                                    this.openAvailModal(
                                                                        availabilityTimes
                                                                    )
                                                                }
                                                            ></i>
                                                            <i
                                                                className="fal fa-trash-alt text-ehite"
                                                                aria-hidden="true"
                                                                style={{ cursor: 'pointer' }}
                                                                onClick={() =>
                                                                    this.openDelete(
                                                                        availabilityTimes.id
                                                                    )
                                                                }
                                                            ></i>
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr className="border-bottom whitespace-nowrap">
                                            <td colSpan="5" className="p-3 text-center text-white">
                                                <div>
                                                    <p>No Schedules Found</p>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <div
                            className="pt-4 overflow-x-auto rounded-lg bg-card bg-gray-50"
                            id="custom"
                            role="tabpanel"
                            aria-labelledby="custom-tab"
                        >
                            <table className="w-full table-bordered">
                                <thead className="text-left text-UInew border-bottom whitespace-nowrap">
                                    <tr>
                                        <th scope="col" className="p-3 font-medium">
                                            Schedule Name
                                        </th>
                                        <th scope="col" className="p-3 font-medium">
                                            Start Date
                                        </th>
                                        <th scope="col" className="p-3 font-medium">
                                            End Date
                                        </th>
                                        <th scope="col" className="p-3 font-medium">
                                            Availability Timing
                                        </th>
                                        <th scope="col" className="p-3 font-medium">
                                            On Demand
                                        </th>
                                        <th scope="col" className="p-3 font-medium">
                                            Actions
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="text-white break-word">
                                    {customAvailTiming && customAvailTiming.length ? (
                                        customAvailTiming.map((availabilityTimes, index) => {
                                            const startDate = moment(
                                                availabilityTimes.startTime
                                            ).format('MMM D, YYYY');
                                            const endDate = moment(
                                                availabilityTimes.endTime
                                            ).format('MMM D, YYYY');
                                            return (
                                                <tr
                                                    key={index}
                                                    className="border-bottom whitespace-nowrap"
                                                >
                                                    <td className="p-3">Schedule {index + 1}</td>
                                                    <td className="p-3">{startDate}</td>
                                                    <td className="p-3">{endDate}</td>
                                                    <td className="p-3">
                                                        {moment
                                                            .tz(
                                                                availabilityTimes.startTime,
                                                                'YYYY-MM-DD HH:mm:ss',
                                                                this.props.timezoneName
                                                            )
                                                            .format('h:mm A')}{' '}
                                                        to{' '}
                                                        {moment
                                                            .tz(
                                                                availabilityTimes.endTime,
                                                                'YYYY-MM-DD HH:mm:ss',
                                                                this.props.timezoneName
                                                            )
                                                            .format('h:mm A')}{' '}
                                                        {this.props.timezoneName}
                                                    </td>
                                                    <td className="p-3">
                                                        {availabilityTimes.availablePerOnDemand
                                                            ? 'Yes'
                                                            : 'No'}
                                                    </td>
                                                    <td className="p-3 text-center">
                                                        <div className="flex gap-2">
                                                            <i
                                                                className="text-white fal fa-edit"
                                                                aria-hidden="true"
                                                                style={{ cursor: 'pointer' }}
                                                                onClick={() =>
                                                                    this.openCustomAvailModal(
                                                                        availabilityTimes
                                                                    )
                                                                }
                                                            ></i>
                                                            <i
                                                                className="text-white fal fa-trash-alt"
                                                                aria-hidden="true"
                                                                style={{ cursor: 'pointer' }}
                                                                onClick={() =>
                                                                    this.openDelete(
                                                                        availabilityTimes.id
                                                                    )
                                                                }
                                                            ></i>
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr className="border-bottom whitespace-nowrap">
                                            <td colSpan="5" className="p-3 text-center text-white">
                                                <div>
                                                    <p>No Schedules Found</p>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
                {this.openDeleteModal()}
                {this.openAvailalibiltyModal()}
                {this.openCustomAvailalibiltyModal()}
            </>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        showNotification: (message, type) => {
            dispatch(showNotification(message, type));
        },
        editAvailability: (value, type) => {
            dispatch(editAvailability(value, type));
        },
        editCustomAvailability: (availableId, value, type) => {
            dispatch(editCustomAvailability(availableId, value, type));
        },
    };
};

export default connect(null, mapDispatchToProps)(Availabilty);
